export enum OrderRefundStatus {
  Refunded = 'refunded',
  // At least one PSP leg of the refund failed; the failed refund payments are retryable (PAUL-2489).
  PartiallyRefunded = 'partially-refunded',
  // A multi-PSP finalize is in flight; resolves to Refunded / PartiallyRefunded once it commits.
  Processing = 'processing',
}
